<i18n src="@/i18n/components/search/search.json"></i18n>
<template>
  <div class="select-by-business-event-form">
    <div class="title">
      <TitleTextWithIcon :title="$t('period')" :icon="iconHistoy" />
    </div>
    <div class="period">
      <DateRangePickerInput
        v-model="dateValue"
        :enabled-period="enabledPeriod"
      />
      <SelectBox v-model="hourValue" class="hour" :options="hourOptions" />
    </div>
    <div class="title">
      <TitleTextWithIcon :title="$t('businessEvent')" :icon="iconConversion" />
    </div>
    <CheckBoxList
      v-model="businessEventValues"
      :column="3"
      :options="businessEventOptions"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Model } from "vue-property-decorator";
import {
  hourlyIntervalsSelectOpitions,
  HOURLY_INTERVALS_DEFAULT_VALUE
} from "@/util/date-util";
import { BusinessEventDefinition } from "@/models/client-settings/BusinessEventDefinition";
import { SelectByBusinessEventCondition } from "@/models/search/select-condition/SelectByBusinessEventCondition";
import DateRangePickerInput from "@/components/date-picker/DateRangePickerInput.vue";
import { DateRange } from "@/components/date-picker/DateRange";
import { enabledPeriodRange } from "@/util/date-range-picker-util";
import TitleTextWithIcon from "@/components/TitleTextWithIcon.vue";
import SelectBox from "@/components/form/SelectBox.vue";
import CheckBoxList from "@/components/form/CheckBoxList.vue";
import SelectOption from "@/components/form/SelectOption";
import { Icons } from "@/const/Icons";

@Component({
  components: {
    DateRangePickerInput,
    TitleTextWithIcon,
    SelectBox,
    CheckBoxList
  }
})
export default class SelectByBusinessEventForm extends Vue {
  @Prop({ type: Array, required: true })
  businessEventDefinitions!: BusinessEventDefinition[];

  @Model("input", { type: SelectByBusinessEventCondition, required: true })
  condition!: SelectByBusinessEventCondition;

  onUpdate(condition: SelectByBusinessEventCondition) {
    this.$emit("input", condition);
  }

  iconConversion = Icons.Conversion;
  iconHistoy = Icons.History;

  get enabledPeriod(): DateRange {
    return enabledPeriodRange();
  }

  // 時間帯Selectのオプション
  get hourOptions(): SelectOption[] {
    return hourlyIntervalsSelectOpitions();
  }

  // ビジネスイベントのcheckboxListのオプション
  get businessEventOptions(): SelectOption[] {
    return this.businessEventDefinitions.map(cd => {
      return { value: cd.id, label: cd.name, disabled: false };
    });
  }

  // 日付の値
  get dateValue(): DateRange | null {
    if (this.condition.endDate !== null && this.condition.startDate !== null) {
      return {
        min: this.condition.startDate,
        max: this.condition.endDate
      };
    }

    return null;
  }
  set dateValue(dateRange: DateRange | null) {
    if (dateRange !== null) {
      const condition = new SelectByBusinessEventCondition(
        this.condition.businessEventDefinitionIds,
        dateRange.min,
        dateRange.max,
        this.condition.hour,
        this.condition.additionalConditions
      );
      this.onUpdate(condition);
    }
  }

  // 時間帯の値
  get hourValue(): number {
    // selectのvalueにnullは渡せないのでnullの場合はHOURLY_INTERVALS_DEFAULT_VALUEを渡す
    return this.condition.hour === null
      ? HOURLY_INTERVALS_DEFAULT_VALUE
      : this.condition.hour;
  }
  set hourValue(hour: number) {
    // HOURLY_INTERVALS_DEFAULT_VALUEだった場合はnullに戻す
    const setHour = hour === HOURLY_INTERVALS_DEFAULT_VALUE ? null : hour;
    const condition = new SelectByBusinessEventCondition(
      this.condition.businessEventDefinitionIds,
      this.condition.startDate,
      this.condition.endDate,
      setHour,
      this.condition.additionalConditions
    );
    this.onUpdate(condition);
  }

  // 選択された値
  get businessEventValues(): number[] {
    return this.condition.businessEventDefinitionIds;
  }
  set businessEventValues(businessEventDefinitionIds: number[]) {
    const condition = new SelectByBusinessEventCondition(
      businessEventDefinitionIds,
      this.condition.startDate,
      this.condition.endDate,
      this.condition.hour,
      this.condition.additionalConditions
    );
    this.onUpdate(condition);
  }
}
</script>

<style scoped lang="scss">
.title {
  margin: 30px 0 10px 0;
  &:first-child {
    margin-top: 0;
  }
}
.period {
  position: relative;
  display: flex;
  height: $formPartsHeight;
}
.hour {
  margin-left: 20px;
}
</style>
